import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const underTwentyFiveAmountDiscountCbState = atom({
  key: "underTwentyFiveAmountDiscountCbState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
